import plausiblePlugin from 'analytics-plugin-plausible';
import Analytics from 'analytics';

export const Coeolytics = () => {
  const baseTrackerPlausible = plausiblePlugin({
    domain: 'coeo.events', // By default window.location.hostname
    hashMode: false, // By default 'false'
    trackLocalhost: false, // By default 'false'
  });

  const conf_full_sub_domain =
    window.CONFERENCE_ID + '.stats.' + process.env.COEO_DOMAIN;

  //If we put both base and conf domain we get one request
  const conferenceTrackerPlausible = {
    // initialize the 2nd instance with 'instanceName' field set
    ...plausiblePlugin({
      domain: conf_full_sub_domain + ', coeo.events', // By default window.location.hostname
      hashMode: false, // By default 'false'
      trackLocalhost: false, // By default 'false'
    }),
    // change 'name' plugin to avoid namespace collisions
    ...{
      name: 'plausiblePlugin-conference',
    },
  };

  const useplugins = [conferenceTrackerPlausible];

  const analytics = Analytics({
    app: 'coeo-app',
    version: 100,
    plugins: useplugins,
  });

  // /autologin/<login code> and /reset/<type>/<recovery code> are login
  // links: the code is part of the page path, so never report those views.
  const trackPage = analytics.page;
  analytics.page = (...args) => {
    if (/\/(autologin|reset)\//.test(window.location.pathname)) {
      return Promise.resolve();
    }
    return trackPage.apply(analytics, args);
  };

  return analytics;
};
